import { Card, ClipboardButton } from 'corso-admin-ui';

export type DataListEntry = {
  label: string;
  value: React.ReactNode;
  copyEnabled?: boolean;
};

function DataListEntry({ label, value, copyEnabled }: DataListEntry) {
  return (
    <div className="flex flex-col gap-1">
      <dt className="flex items-center gap-1 text-xs font-semibold tracking-wider text-neutral-500 uppercase">
        {label}
        {copyEnabled &&
          (typeof value === 'string' || typeof value === 'number') && (
            <ClipboardButton
              variant="ghost"
              accessibilityLabel={`Copy ${label}`}
              onClick={() => `${value}`}
            />
          )}
      </dt>
      <dd className="text-sm text-neutral-900">{value}</dd>
    </div>
  );
}

export function DataList({ items }: { items: DataListEntry[] }) {
  return (
    <dl className="grid grid-cols-1 gap-3 sm:grid-cols-2 m-2">
      {items.map((item) => (
        // oxlint-disable-next-line react/jsx-props-no-spreading
        <DataListEntry key={item.label} {...item} />
      ))}
    </dl>
  );
}

export function DataListCard({
  title,
  items,
}: {
  title?: string;
  items: DataListEntry[];
}) {
  return (
    <Card>
      {title && <Card.Heading>{title}</Card.Heading>}
      <DataList items={items} />
    </Card>
  );
}
